addEventListener('DOMContentLoaded', () => {

  const accordionButtons = document.querySelectorAll('#menu-dropdown');

  accordionButtons.forEach(button => {
    button.addEventListener('click', function() {
      const panel = button.nextElementSibling;
      const icon = button.querySelector('svg');

      button.classList.toggle('active');

      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
      
      // Rotate the icon
      if (button.classList.contains('active')) {
        icon.style.transform = 'rotate(180deg)';
      } else {
        icon.style.transform = 'rotate(0deg)';
      }
    });
  });

});
